import React from 'react'
import ChatBubble from "./Components/ChatContent"
import "../../../styles/hisopado/chatStyles.scss"

export default function DeliveryChat() {
    return (
        <div className="chat__container">
            <ChatBubble />
        </div>
    )
}
